import React from 'react'
import { Link } from 'react-router-dom'
import {
    Navbar,
    NavItem,
    Nav,
} from 'reactstrap'
import { useTranslation } from 'react-i18next'

import Logo from '../../components/common/Logo'
import TopNavRightSideNavItem from './TopNavRightSideNavItem'
import { useAppSelector } from '../../hooks/redux'

/**
 * Shape of the authed user object stored in the auth slice.
 * Defined locally because auth.user is typed as `unknown` in the reducer.
 */
interface AuthedUser {
    superAdmin?: boolean
}

/**
 * Top application navigation bar.
 *
 * Renders the logo, primary nav links and the right-side user/language
 * controls. The admin users link is only shown to super-admin users.
 */
const NavbarTop = () => {
    const { t } = useTranslation()
    const authedUser = useAppSelector(state => state.auth.user) as AuthedUser | null

    return (
        <Navbar
            light
            className='navbar-glass fs--1 row navbar-top sticky-kit'
        >
            <Logo at='navbar-top' width={100} id='topLogo' />
            <Nav>
                <NavItem>
                    <Link className='nav-link' to='/devices'>
                        {t('device.devices')}
                    </Link>
                </NavItem>
                {authedUser?.superAdmin &&
                    <NavItem>
                        <Link className='nav-link' to='/admin/users'>
                            {t('users.users')}
                        </Link>
                    </NavItem>
                }
                <NavItem>
                    <Link className='nav-link' to='/admin/users/companies'>
                        {t('company.companies')}
                    </Link>
                </NavItem>
            </Nav>
            <TopNavRightSideNavItem />
        </Navbar>
    )
}

export default NavbarTop
